import { createSelector } from '@reduxjs/toolkit'

const findIfElseContent = (section, selectedRow, selectedRowContent) => {
    if (!selectedRowContent && selectedRow.indexOf('if') !== -1) {
        const parentRowId = selectedRow.substring(0, selectedRow.indexOf('if'));
        const parentRow = section.find((content) => content.id === parentRowId);
        return parentRow.config.if && parentRow.config.if.content.find((content) => content.id === selectedRow);
    } else if (!selectedRowContent && selectedRow.indexOf('else') !== -1) {
        const parentRowId = selectedRow.substring(0, selectedRow.indexOf('else'));
        const parentRow = section.find((content) => content.id === parentRowId);
        return parentRow.config.else && parentRow.config.else.content.find((content) => content.id === selectedRow);
    }
    return selectedRowContent;
}

export const getSelectedRowContent = createSelector(
    [
        state => state.design.header,
        state => state.design.body,
        state => state.design.footer,
        state => state.row.selected
    ],
    (header, body, footer, selectedRow) => {
        let selectedRowContent;
        if (selectedRow.indexOf('header') !== -1) {
            selectedRowContent = header.find((content) => content.id === selectedRow);
            selectedRowContent = findIfElseContent(header, selectedRow, selectedRowContent);
        } else if (selectedRow.indexOf('body') !== -1) {
            selectedRowContent = body.find((content) => content.id === selectedRow);
            selectedRowContent = findIfElseContent(body, selectedRow, selectedRowContent);
        } else if (selectedRow.indexOf('footer') !== -1) {
            selectedRowContent = footer.find((content) => content.id === selectedRow);
            selectedRowContent = findIfElseContent(footer, selectedRow, selectedRowContent);
        }
        return selectedRowContent;
    }
)

export const isImage = createSelector(
    [getSelectedRowContent], 
    selectedRowContent => selectedRowContent && selectedRowContent.type === 'image'
);

export const isText = createSelector(
    [getSelectedRowContent], 
    selectedRowContent => selectedRowContent && selectedRowContent.type === 'text'
);

export const isIfElse = createSelector(
    [getSelectedRowContent], 
    selectedRowContent => selectedRowContent && selectedRowContent.type === 'ifelse'
);

export const isIf = createSelector(
    [getSelectedRowContent],
    selectedRowContent => selectedRowContent && selectedRowContent.type === 'if'
);

export const isMjml = createSelector(
    [getSelectedRowContent],
    selectedRowContent => selectedRowContent && selectedRowContent.type === 'mjml'
);